module.exports = __webpack_public_path__ + "static/award11-0152748386fdad24e69718343ec44bcb.png";